import React, { useState, useEffect, useContext, useRef } from "react";
import MUIDataTable from "mui-datatables";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Link,
  Menu,
  Autocomplete,
  // InputAdornment,
  // IconButton,
} from "@mui/material";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
// import Tooltip from "@mui/material/Tooltip";
import IconUI from "../components/iu/icon_ui";
import { 
  AiOutlineDelete, 
  AiOutlineSelect,
} from "react-icons/ai";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment/moment";
import { maxLengthLimitInput, onlyNumber } from "../utils/inputsRules";
import { formatAuthorityCrimes } from "../utils/formatAuthorityCrimes";
import { GlobalContext } from "../context/global_context";
import { useLocation, useParams } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import SearchIcon from "@mui/icons-material/Search";
// import { RiFileExcel2Line } from "react-icons/ri";
// import PriorityHigh from "@mui/icons-material/PriorityHigh";
import ModalText from "../components/ModalText";

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTable: {
        styleOverrides: {
          root: {
            borderRadius: "30px !important",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#3c6218 !important",

            color: "white",
          },
        },
      },
    },
  });

const PeticionesVictimasView = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
  };

  const styleDetalles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min(700px, calc(100vw - 32px))",
    maxHeight: "calc(100dvh - 32px)",
    boxSizing: "border-box",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: { xs: 2, sm: 4 },
    overflowY: "auto",
    overflowX: "hidden",
    borderRadius: { xs: "20px", sm: "40px" },
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#c4c4c4",
      borderRadius: "10px",
    },
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 700,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#c4c4c4",
      borderRadius: "10px",
    },
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",

    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    width: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",

    "&:hover": {
      backgroundColor: "#661d40",

    },
    borderRadius: "40px",
  }));

  const colorTitle = {
    fontWeight: 800,
    color: "#661d40",
    letterSpacing: "0.5px",
    fontSize: "16px",
  };
  // const goTo = useNavigate();
  const location = useLocation();
  const routeParams = useParams();
  const searchParams = new URLSearchParams(location.search);

  const applicationId = routeParams.applicationId ?? searchParams.get("application_id");
  const status_group = routeParams.status_group ?? searchParams.get("status_group");
  const { setPeticion } = useContext(GlobalContext);
  const [state, setState] = useState({
    citizens: [],
    requests: [],
    detalles:[],
    ciudadano: [],
    tiposPeticion: [],
    areas: [],
    status:[],
    municipios: [],
    localidades: [],
    citizenSelected: "",
    dateSelected: "",
    fontSelected: "",
    numTour: "",
    nameTour: "",
    observations: "",
    fonts: [],

    openDescripcion: false,
    openEditarCiudadano: false,
    citizenEditSelected: {},
    openFiltro: false,
    openDetalles: false,
    openAdjuntos: false,
    adjuntos: [],
    openAsesores: false,
    asesores:[],
    asesorSeleccionado: null,
    openPreviewDocumento: false,
    previewDocumentoUrl: "",
    previewDocumentoNombre: "",
    previewDocumentoMime: "",
  });

  const [buscador, setBuscador] = useState({
    texto: "",
    error: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const validarArchivoPdf = (file) => {
    if (!file) return false;

    const isPdf = file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf");
    const isValidSize = file.size <= 5 * 1024 * 1024;

    if (!isPdf) {
      showNotification(
        "error",
        "Archivo no permitido",
        "Solo se permiten archivos PDF.",
        null,
        4,
      );
      return false;
    }

    if (!isValidSize) {
      showNotification(
        "error",
        "Archivo muy pesado",
        "El archivo debe pesar menos de 5 MB.",
        null,
        4,
      );
      return false;
    }

    return true;
  };
  
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;
    if (!validarArchivoPdf(file)) {
      event.target.value = "";
      return;
    }

    setSelectedFile(file);
  };
  
  
  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedItemId(data);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const [exportarBandera, setExportarBandera] = useState(1);

  // const [titulosState, setTitulos] = useState({
  //   data: [],
  // });
  // const [cargosState, setCargos] = useState({
  //   data: [],
  // });

  const [formularioState, setFormulario] = useState({
    ciudadano_id: "",
    observaciones: "",
    fuente_solicitud_id: "",
    fecha_audiencia: "",
    numero_gira: "",
    lugar_gira: "",
  });

  const [formularioPeticionState, setFormularioPeticion] = useState({
    // tipo_peticion_id: "",
    subject: "",
    priority: "",
    area_id: "",
    // atencion_inmediata: true,
  });

  const [filtroSolicitud, setFiltroSolicitud] = useState({
    cantidad: 10,
    folio: "",
    ciudadano: "",
    fecha: null,
    estado: "",
    fuente_solicitud: "",
    numero_gira: "",
    lugar_gira: "",
  });

  const [loader, setLoader] = useState({
    loading: false,
  });
  
  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;

  const formatDisplayDate = (value) => {
    if (!value) return "-";
    return moment.utc(value).local().format("DD-MM-YYYY");
  };

  const handleFiltroFolio = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, folio: e.target.value });
  };
  const handleFiltroCiudadano = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, ciudadano: e.target.value });
  };
  const handleFiltroEstado = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, estado: e.target.value });
  };
  const handleFiltroFecha = (e) => {
    const selectedDate = dayjs(e.$d);
    setFiltroSolicitud({
      ...filtroSolicitud,
      fecha: selectedDate.format("YYYY-MM-DD"),
    });
  };
  const handleFiltroFuente = (e) => {

    setFiltroSolicitud({
      ...filtroSolicitud,
      fuente_solicitud: e.target.value,
    });
  };
  const handleFiltroNumero = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, numero_gira: e.target.value });
  };
  const handleFiltroLugar = (e) => {
    setFiltroSolicitud({ ...filtroSolicitud, lugar_gira: e.target.value });
  };

  const limpiarFiltros = () => {
    setFiltroSolicitud({
      ...filtroSolicitud,
      folio: "",
      ciudadano: "",
      fecha: null,
      estado: "",
      fuente_solicitud: "",
      numero_gira: "",
      lugar_gira: "",
    });
  };

  const [openModal, setopenModal] = useState(false);
  const [openModalPeticion, setOpenModalPeticion] = useState(false);
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const [openModalEliminarState, setOpenModalEliminar] = useState(false);
  // const [openModalCrear, setOpenModalCrear] = useState(false);

  const { showNotification } = useContext(NotificacionContext);

  const [errors, setErrors] = useState({});

  const normalizeValue = (value) =>
    value?.toUpperCase().replace(/[_\s]/g, "") || "";

  const allowedEditRoles = ["ASESOR", "PSICOLOGO", "PRIMERCONTACTO"];
  const currentRole = normalizeValue(localStorage.getItem("rol"));
  const canEditRequest = allowedEditRoles.includes(currentRole);

  const storedAreaType = normalizeValue(
    localStorage.getItem("type_area") || localStorage.getItem("area_type") || ""
  );
  const userDependency = normalizeValue(localStorage.getItem("dependencia"));

  const isLectura =normalizeValue(localStorage.getItem("rol")) === "LECTURA";
  const isAdministrador =normalizeValue(localStorage.getItem("rol")) === "ADMIN";
  const isAsesor = normalizeValue(localStorage.getItem("rol")) === "ASESOR";
  const isPsicologo = normalizeValue(localStorage.getItem("rol")) === "PSICOLOGO";
  const canSeeReturnar =normalizeValue(localStorage.getItem("rol")) === "AREA";


  const showServiceColumn = storedAreaType === "AREAPSICOLOGICA";
  
  const isAreaJuridica = storedAreaType === "AREAJURIDICA";
  
  const isFondoAyuda = storedAreaType === "AREADEFONDODEAYUDA";

  const isUnidadesRegionales = storedAreaType === "AREADEUNIDADESREGIONALES";
    
  const isAreaPsicologica = storedAreaType === "AREAPSICOLOGICA";

  const isAcompañamientoVictimas = storedAreaType === "AREADEATENCIÓNYACOMPAÑAMIENTOAVÍCTIMAS";
  
  const isPrimerContacto =storedAreaType === "PRIMERCONTACTO";

  const isDH = userDependency === "UNIDADDEDERECHOSHUMANOSYOTRASMATERIAS";
  const EsconderAsesores = isAsesor && !isDH;
  const isStatusEnTramite = Number(state.citizenEditSelected.status_id) === 3;
  const currentOtherAccions =
    state.citizenEditSelected?.other_accions ??
    state.citizenEditSelected?.procedural_states?.[0]?.other_accions ??
    "";
  const isImpugnaciones = currentOtherAccions === "IMPUGNACIONES";

  const openModalDescripcion = (data) => {
    setState({
      ...state,
      openDescripcion: true,
      descripcion: data,
    });
  };
  const handleCloseDescripcion = () => {
    setState({ ...state, openDescripcion: false });
  };
  // const openModalCrearPeticion = async (data) => {
  //   setLoader({ ...loader, loading: true });
   
  //   const areas = await services({
  //     method: "GET",
  //     service: "areas",
  //     body: null,
  //   });
  //   if (areas.status === 200) {
  //     setState({
  //       ...state,
  //       citizenEditSelected: data,
  //       areas: areas.data,
  //     });
  //     setOpenModalPeticion(true);
  //     setLoader({ ...loader, loading: false });
  //   }
  // };

  const openModalAsesores = async () => {
    setLoader({ ...loader, loading: true });
    let listaAsesores = await services({
      method: "GET", 
      service: `/user/adviser`,
      body: null,
    });
    if (listaAsesores.status === 200) {
      setLoader({ ...loader, loading: false });
      setState({
        ...state,
        openAsesores: true,
        asesores: listaAsesores.data,
      });
      handleMenuClose();
    } else {  
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        "No se lograron cargar los archivos adjuntos",
        null,
        4
      );
    }
  };

  const normalizarAdjuntos = (payload) => {
    if (!payload) return [];

    if (Array.isArray(payload)) return payload;

    return [
      ...(Array.isArray(payload.petition_documents) ? payload.petition_documents : []),
      ...(Array.isArray(payload.application_documents) ? payload.application_documents : []),
    ];
  };

  const openModalAdjuntos = async () => {
    setLoader({ ...loader, loading: true });
    let listaAdjuntos = await services({
      method: "GET",
      service: `/petitions/${selectedItemId.id}/documents`,
      body: null,
    });

    if (listaAdjuntos.status === 200) {
      const documentos = normalizarAdjuntos(listaAdjuntos.data || listaAdjuntos);

      setLoader({ ...loader, loading: false });
      setState({
        ...state,
        openAdjuntos: true,
        adjuntos: documentos,
      });
      handleMenuClose();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        "No se lograron cargar los archivos adjuntos",
        null,
        4
      );
    }
  };

  const handleCloseAdjuntos = () => {
    setState({ ...state, openAdjuntos: false });
    setSelectedFile(null);
  };

  const handleCloseAsesores = () => {
    setState((prev) => ({
      ...prev,
      openAsesores: false,
      asesorSeleccionado: null,
    }));
  };
  const openModalDetalles = async () => {
    setLoader({ ...loader, loading: true });
    let detalles = await services({
      method: "GET",
      service: `petitions/${selectedItemId.id}`,
      body: null,
    });
    if (detalles.status === 200) {
      setLoader({ ...loader, loading: false });
      setState({ ...state, detalles: detalles.data.data, openDetalles: true });
      handleMenuClose();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "ups... Algo sucedió",
        "Error al obtener información",
        null,
        4
      );
      handleMenuClose();
    }
  };
  const handleCloseDetalles = () => {
    setState({ ...state, openDetalles: false });
  };
  const openmodal = async (data) => {
    if (!(isAdministrador || canEditRequest || isFondoAyuda || isAcompañamientoVictimas)) {
      showNotification(
        "error",
        "Acceso denegado",
        "Solo los usuarios con rol autorizado pueden editar esta solicitud",
        null,
        4,
      );
      return;
    }

    const areas = await services({
      method: "GET",
      service: "areas/by-municipality",      
      body: null,
    });
    const status = await services({
      method: "GET",
      service: "status",
      body: null,
    });

    if (areas.status === 200 && status.status === 200) {
      setState((prev) => ({
        ...prev,
        areas: areas.data,
        status: status.data,
        citizenEditSelected: data,
      }));
      setOpenModalEditar(true);
      handleMenuClose();
    }
  };

  // const openModalAñadir = async () => {
  //   setLoader({ ...loader, loading: true });
  //   const victims = await services({
  //     method: "GET",
  //     service: "victims/name",
  //     body: null,
  //   });

  //   if (victims.status === 200) {
  //     setState({
  //       ...state,
  //       citizens: victims.data,
  //     });
  //     setLoader({ ...loader, loading: false });
  //     setopenModal(true);
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "Ups...Algo sucedió",
  //       "Al cargar las solicitudes",
  //       null,
  //       4,
  //     );
  //   }
  // };
    
  const [totalSolicitudes, setTotalSolicitudes] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const normalizePaginatedResponse = (payload) => {
    const source = payload?.data ?? payload ?? {};
    const rows = Array.isArray(source?.data)
      ? source.data
      : Array.isArray(source)
        ? source
        : [];
    const total = Number(source?.total ?? payload?.total ?? rows.length ?? 0);

    return { rows, total };
  };

  const getCitizensAndRequests = async (pageIndex = 0, rowsPerPage = 10, applicationId = null, status_group = null,) => {
    if (buscar) {
      setBuscar(false);
      pageIndex = 0;
      setPage(0);
      setBuscador({ ...buscador, error: "" });
    }
    let url = `petitions/?page=${pageIndex + 1}`;
    if (applicationId) {
      url += `&application_id=${applicationId}`;
    }
    if (status_group) {
       url += `&status_group=${status_group}`;
    }

    let requests = await services({
      method: "GET",
      service: url,
      body: null,
    });

    if (requests.status === 200) {
      const { rows, total } = normalizePaginatedResponse(requests.data);
      setState((prev) => ({
        ...prev,
        requests: rows,
        openEditarCiudadano: false,
        openFiltro: false,
      }));

      setTotalSolicitudes(total);

      setLoader({ ...loader, loading: false });

    } else {

      setLoader({ ...loader, loading: false });

      showNotification(
        "error",
        "Ups...Algo sucedió",
        "Al cargar las solicitudes",
        null,
        4,
      );
    }
  };

  const recargarPeticiones = (pageIndex = page) =>
    getCitizensAndRequests(pageIndex, pageSize, applicationId, status_group);

  const validarBuscador = async (pageIndex = 0) => {
    if (!buscador.texto) {
      const pagOriginal = 0;
      recargarPeticiones(pagOriginal);
      setBuscador({ ...buscador, error: "El campo no puede ir vacío" });
      setTimeout(() => {
        setBuscador({ ...buscador, error: "" });
      }, 3000);
    } else {
      // setExportarBandera(1);
      setLoader({ ...loader, loading: true });
      const body = {
        buscador: buscador.texto,
        cantidad: 10,
      };
      const request = await services({
        method: "POST",
        service: `solicitudes/buscarSolicitud?page=${pageIndex + 1}`,
        body,
      });

      if (request.status === 200) {
        const { rows, total } = normalizePaginatedResponse(request.data);
        setBuscar(true);
        setBuscador({ ...buscador, error: "" });
        setState({ ...state, requests: rows });
        setTotalSolicitudes(total);
        setLoader({ ...loader, loading: false });
        limpiarFiltros();
      } else if (request.status === 500) {
        setLoader({ ...loader, loading: false });
        setBuscador({
          ...buscador,
          error: "Ha ocurrido un error en el servidor",
        });
      } else {
        setLoader({ ...loader, loading: false });
        setBuscador({ ...buscador, error: request.data.message });
      }
    }
  };

  // const openModalFiltro = async () => {
  //   setLoader({ ...loader, loading: true });
  //   const fonts = await services({
  //     method: "GET",
  //     service: "catFuentesSolicitudes/listar",
  //     body: null,
  //   });
  //   if (fonts.status === 200) {
  //     setLoader({ ...loader, loading: false });
  //     setState({ ...state, openFiltro: true, fonts: fonts.data.data });
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "Ups...Algo sucedió",
  //       "Al cargar las solicitudes",
  //       null,
  //       4,
  //     );
  //   }
  // };

  // const exportar = async () => {
  //   setLoader({ ...loader, loading: true });

  //   const body = {
  //     folio: filtroSolicitud.folio,
  //     ciudadano: filtroSolicitud.ciudadano,
  //     fecha: filtroSolicitud.fecha,
  //     estado: filtroSolicitud.estado,
  //     fuente_solicitud: filtroSolicitud.fuente_solicitud,
  //     numero_gira: filtroSolicitud.numero_gira,
  //     lugar_gira: filtroSolicitud.lugar_gira,
  //     buscador: buscador.texto,
  //     exportar: exportarBandera,
  //   };

  //   let response = await services(
  //     {
  //       method: "POST",
  //       service: `solicitudes/exportar`,
  //       body: body,
  //     },
  //     {
  //       responseType: "arraybuffer",
  //     },
  //   );
  //   if (response.status === 200) {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "success",
  //       "Éxito",
  //       "Se ha descargado su archivo",
  //       null,
  //       4,
  //     );
  //     const link = document.createElement("a");
  //     link.href = `data:application/octet-stream;base64,${response.data.archivo}`;
  //     link.download = "Solicitudes.xlsx";
  //     link.click();
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "Ups...",
  //       "Ocurrió algo al descargar su archivo",
  //       null,
  //       4,
  //     );
  //   }
  // };

  const customOptions = {
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    serverSide: true,
    count: totalSolicitudes,
    page,
    rowsPerPage,
    onTableChange: async (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      }
      if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
    rowsPerPageOptions: [],
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
      },
    },
  };

  // const openModalEditarCiudadano = async (data) => {
  //   setLoader({ ...loader, loading: true });
  //   const titulos = await services({
  //     method: "GET",
  //     service: `catTiposTitulos/listar`,
  //     body: null,
  //   });
  //   const cargos = await services({
  //     method: "GET",
  //     service: `catTipoCargos/listarCargos`,
  //     body: null,
  //   });
  //   const municipios = await services({
  //     method: "GET",
  //     service: `catMunicipios/listar`,
  //     body: null,
  //   });
  //   let ciudadano = await services({
  //     method: "POST",
  //     service: `ciudadanos/mostrar`,
  //     body: { id: data.ciudadano_id },
  //   });
  //   if (
  //     ciudadano.status === 200 &&
  //     titulos.status === 200 &&
  //     cargos.status === 200
  //   ) {
  //     setLoader({ ...loader, loading: false });
  //     setTitulos({ ...titulosState, data: titulos.data.data });
  //     setCargos({ ...cargosState, data: cargos.data.data });
  //     setState({
  //       ...state,
  //       ciudadano: ciudadano.data.data,
  //       openEditarCiudadano: true,
  //       municipios: municipios.data.data,
  //     });
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "ups... Algo sucedió",
  //       "Error al obtener información",
  //       null,
  //       4,
  //     );
  //     handleCloseEditarCiudadano();
  //   }
  // };

  const openModalEliminar = (data) => {
    setState({ ...state, citizenEditSelected: data });
    setOpenModalEliminar(true);
    handleMenuClose();
  };

  // const handleChangeBuscador = (e) => {
  //   setBuscador({ ...buscador, texto: e.target.value });
  // };

  const [buscar, setBuscar] = useState(false);

  const columns = [
    {
      name: "folio",
      label: "N° VICTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let folio = state.requests[dataIndex].application?.folio;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {folio}
            </div>
          );
        },
      },
    },
    {
      name: "fecha_creacion",
      label: "FECHA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const fecha = formatDisplayDate(
            state.requests[dataIndex]?.created_at,
          );

          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {fecha}
            </div>
          );
        },
      },
    },
    {
      name: "victim",
      label: "VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let victim = `${state.requests[dataIndex].application?.victim?.name} ${state.requests[dataIndex].application?.victim?.first_lastname} ${state.requests[dataIndex].application?.victim?.second_lastname ? state.requests[dataIndex].application?.victim?.second_lastname : ""}`;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {victim}
            </div>
          );
        },
      },
    },
    {
      name: "phone",
      label: "CONTACTO",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let phone = state.requests[dataIndex].application?.victim?.phone;
          return (
            <div
              className=" d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {phone}
            </div>
          );
        },
      },
    },
    {
      name: "victim_type",
      label: "TIPO DE VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let tipo_victima = state.requests[dataIndex].application?.victim?.victim_type;
          return (
            <div
              className=" d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {tipo_victima}
            </div>
          );
        },
      },
    },
    {
      name: "municipio",
      label: "MUNICIPIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipio = state.requests[dataIndex].application?.victim?.municipality?.name;
          if (municipio !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {municipio}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    ...(isPrimerContacto
      ? [
        {
          name: "origen_destino",
          label: "REGIÓN",
          options: {
            filter: true,
            sort: false,
            download: false,
            customBodyRenderLite: (dataIndex) => {
              let region = state.requests[dataIndex].user?.area?.municipality;
              return (
                <div
                  className="d-flex align-items-center"
                  style={{ height: "60px" }}
                >
                  {region}
                </div>
              );
            },
          },
        },
      ]
    : []),
    {
      name: "crime",
      label: "DELITO / VIOL. D.H.",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const authority =
            state.requests[dataIndex]?.application?.victim?.authority;
          const crimeDescription = formatAuthorityCrimes(authority);
          const isLongDescription = crimeDescription.length > 50;

          return (
            <div
              className={`d-flex align-items-center${isLongDescription ? " cursor-pointer" : ""}`}
              style={{ height: "60px" }}
              onClick={
                isLongDescription
                  ? () => openModalDescripcion(crimeDescription)
                  : undefined
              }
            >
              {isLongDescription
                ? `${crimeDescription.substring(0, 50)} ...`
                : crimeDescription}
            </div>
          );
        },
      },
    },
    {
      name: "folios",
      label: "A.P.-C.I./NO.EXP",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let ap = state.requests[dataIndex].application?.victim?.authority?.mp_file_type;
          let exp = state.requests[dataIndex].application?.victim?.authority?.mp_exp;
          if (ap !== null || exp !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {/* {ap} {exp ? `/ ${exp}` : ""} {folio_dh ? `/ ${folio_dh}` : ""} */}
                {ap}{exp ? ` / ${exp}` : ""}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "subject",
      label: "PETICIÓN/SERVICIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let nuc = state.requests[dataIndex].subject;
          if (nuc !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {nuc}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "priority",
      label: "PRIORIDAD",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let priority = state.requests[dataIndex].priority;
          if (priority !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {priority}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "nuc",
      label: "NUC",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let nuc = state.requests[dataIndex].application?.victim?.authority?.mp_nuc;
          if (nuc !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {nuc}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    // {
    //   name: "process_number",
    //   label: "C.PENAL / C.ANTECEDENTES",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRenderLite: (dataIndex) => {
    //       let process_number = state.requests[dataIndex].application?.victim?.authority?.process_number;
    //       let ca = state.requests[dataIndex].application?.victim?.authority?.CA;
    //       if (process_number !== null || ca !== null) {
    //         return (
    //           <div
    //             style={{ height: "60px" }}
    //             className="d-flex align-items-center"
    //           >
    //             {process_number}{ca ? ` / ${ca}` : ""}
    //           </div>
    //         );
    //       } else {
    //         return (
    //           <div
    //             style={{ height: "60px" }}
    //             className="d-flex align-items-center justify-content-center"
    //           >
    //             -
    //           </div>
    //         );
    //       }
    //     },
    //   },
    // },
    {
      name: "revim",
      label: "REVIM",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let revim = state.requests[dataIndex].application?.REVIM;
          if (revim !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {revim}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "renavi",
      label: "RENAVI",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let renavi = state.requests[dataIndex].application?.RENAVI;
          if (renavi !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {renavi}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    ...(showServiceColumn
      ? [
          {
            name: "servicio",
            label: "SERVICIO",
            options: {
              filter: true,
              sort: false,
              customBodyRenderLite: (dataIndex) => {
                const services = state.requests[dataIndex].services_provided;
                const formattedServices = Array.isArray(services)
                  ? services.join(", ")
                  : services || "";

                if (formattedServices) {
                  return (
                    <div
                      style={{ height: "60px" }}
                      className="d-flex align-items-center"
                    >
                      {formattedServices}
                    </div>
                  );
                } else {
                  return (
                    <div
                      style={{ height: "60px" }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      -
                    </div>
                  );
                }
              },
            },
          },
        ]
      : []),
      ...(isAsesor || isAreaJuridica || isAdministrador
      ? [
      {
        name: "sede",
        label: "SEDE",
        options: {
          filter: true,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            const proceduralState = state.requests[dataIndex]?.procedural_states?.[0];
            const sede = proceduralState?.sede;
            if (sede) {
              return (
                <div
                  style={{ height: "60px" }}
                  className="d-flex align-items-center"
                >
                  {sede}
                </div>
              );
            } else {
              return (
                <div
                  style={{ height: "60px" }}
                  className="d-flex align-items-center justify-content-center"
                >
                  -
                </div>
              );
            }
          },
        },
      },
    ]
    : []),
    {
      name: "status",
      label: "ESTATUS",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let renavi = state.requests[dataIndex].status?.name;
          if (renavi !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {renavi}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "observation",
      label: "OBSERVACIONES",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let descripcion = state.requests[dataIndex].observations;

          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center cursor-pointer"
              onClick={() => {
                openModalDescripcion(descripcion);
              }}
            >
              {descripcion
                ? descripcion.substring(0, 50)
                : "-"}{" "}
              ...
            </div>
          );
        },
      },
    },
    ...(isAsesor || isAreaJuridica || isAdministrador
    ? [
      {
        name: "otras_acciones",
        label: "OTRAS ACCIONES",
        options: {
          filter: true,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            const proceduralState = state.requests[dataIndex]?.procedural_states?.[0];
            const otras_acciones = proceduralState?.other_accions;
            if (otras_acciones) {
              return (
                <div
                  style={{ height: "60px" }}
                  className="d-flex align-items-center"
                >
                  {otras_acciones}
                </div>
              );
            } else {
              return (
                <div
                  style={{ height: "60px" }}
                  className="d-flex align-items-center justify-content-center"
                >
                  -
                </div>
              );
            }
          },
        },
      },
    ]
    : []),
    ...(isPrimerContacto || isAdministrador || isLectura
      ? [
        {
          name: "area_id",
          label: "AREA_ATIENDE",
          options: {
            filter: true,
            sort: false,
            customBodyRenderLite: (dataIndex) => {
              let renavi = state.requests[dataIndex].area?.name;
              if (renavi !== null) {
                return (
                  <div
                    style={{ height: "60px" }}
                    className="d-flex align-items-center"
                  >
                    {renavi}
                  </div>
                );
              } else {
                return (
                  <div
                    style={{ height: "60px" }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    -
                  </div>
                );
              }
            },
          },
        },
      ]
    : []),
    ...(isAreaJuridica
      ? [
        {
          name: "judgment",
          label: "ASUNTO OTRAS MATERIAS",
          options: {
            filter: true,
            sort: false,
            download: false,
            customBodyRenderLite: (dataIndex) => {
              let judgment = state.requests[dataIndex].judgment;
              return (
                <div
                  className=" d-flex align-items-center"
                  style={{ height: "60px" }}
                >
                  {judgment}
                </div>
              );
            },
          },
        },
      ]
    : []),
    {
      name: "adviser_id",
      label: "ASESOR/PSICOLÓGO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let adviser = state.requests[dataIndex].adviser?.name;
          if (adviser !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {adviser}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              <Button
                onClick={(event) =>
                  handleMenuClick(event, state.requests[dataIndex])
                }
              >
                <IconUI size={"20px"} color={"black"}>
                  <AiOutlineSelect />
                </IconUI>
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {/* {(selectedItemId?.estatus_peticion_id === 4 ||
                  selectedItemId?.estatus_peticion_id === 6 ||
                  selectedItemId?.estatus_peticion_id === 9) &&
                  selectedItemId?.acuse === "SIN ACUSE" ? (
                  <MenuItem
                    onClick={() => {
                      handleAcuse(selectedItemId.id);
                    }}
                  >
                    GENERAR ACUSE
                  </MenuItem>
                ) : (
                  <div></div>
                )} */}
                {(canSeeReturnar && !(isFondoAyuda || isAcompañamientoVictimas)) && (
                  <MenuItem onClick={openModalAsesores}>RETURNAR</MenuItem>
                )}
                <MenuItem onClick={openModalDetalles}>DETALLES</MenuItem>

                {((isAdministrador || canEditRequest || isFondoAyuda || isAcompañamientoVictimas)) && (
                  <MenuItem onClick={() => openmodal(selectedItemId)}>EDITAR</MenuItem>
                )}
                <MenuItem onClick={openModalAdjuntos}>ADJUNTOS</MenuItem>    
                
                {isAdministrador && ( 
                <MenuItem onClick={() => openModalEliminar(selectedItemId)}>ELIMINAR PETICIÓN</MenuItem>  
                )}                 
              </Menu>
            </div>
          );
        },
      },
    },
  ];

  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.victim_id) {
      newErrors.citizen = "Este Campo es requerido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};
    if (!state.citizenEditSelected.judgment) {
      newErrors.judgment = "Este Campo es requerido";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarTurnarAsesor = () => {
    let newErrors = {};
    if (!state.asesorSeleccionado ) {
      newErrors.asesor = "Este Campo es requerido";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const regexEmail = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;

  const normalizeServicesProvided = (value) => {
    if (Array.isArray(value)) return value;
    if (!value) return [];
    if (typeof value === "string") {
      return value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return [];
  };

  const selectedServices = normalizeServicesProvided(
    state.citizenEditSelected.services_provided,
  );
  const hasPsicoterapiaService = selectedServices.includes("PSICOTERAPIA");
  const hasSelectedServices = selectedServices.length > 0;
  const shouldShowStatusField =!isPrimerContacto && ((isPsicologo && hasPsicoterapiaService) || !hasSelectedServices);

  const validarEditarCiudadano = () => {
    let newErrors = {};
    if (!state.ciudadano.nombre) {
      newErrors.nombre = "Este Campo es Requerido";
    }
    if (!state.ciudadano.apellido_paterno) {
      newErrors.apellidoPaterno = "Este Campo es Requerido";
    }
    if (state.ciudadano.tipo_persona === "") {
      newErrors.tipo = "Este Campo es Requerido";
    }
    if (
      state.ciudadano.ine !== null &&
      state.ciudadano.ine !== "" &&
      state.ciudadano.ine.length < 13
    ) {
      newErrors.ine = "Favor poner un número de identificación válido";
    }
    if (
      state.ciudadano.telefono !== null &&
      state.ciudadano.telefono.length < 10
    ) {
      newErrors.telefono = "Favor poner un número de 10 dígitos";
    }
    if (state.ciudadano.cp !== null && state.ciudadano.cp.length < 5) {
      newErrors.cp = "Favor poner un código postal válido";
    }

    if (state.ciudadano.email !== null && state.ciudadano.email !== "") {
      let valido = regexEmail.test(state.ciudadano.email);
      if (!valido) {
        newErrors.email = "Ingrese un email válido";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarFormularioPeticion = () => {
    let newErrors = {};
    if (!formularioPeticionState.area_id) {
      newErrors.area_id = "Este Campo es requerido";
    }
    if (!formularioPeticionState.priority) {
      newErrors.priority = "Este Campo es requerido";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const limpiarFormularioPeticion = () => {
    setFormularioPeticion({
      ...formularioPeticionState,
      subject: "",
      area_id: "",
      priority: "",
    });
  };

  const limpiarFormulario = () => {
    setFormulario({
      ...formularioState,
      collective: "",
      observations: "",
      victim_id: "",
    });
  };

  const createRequest = async () => {
    if (validarFormulario()) {
      setLoader({ ...loader, loading: true });
      const body = {
        collective: formularioState.collective,
        observations: formularioState.observations?.toUpperCase(),
        victim_id: formularioState.victim_id,
      };
      const request = await services({
        method: "POST",
        service: "applications",
        body,
      });
      if (request.status === 201) {

        recargarPeticiones();
        limpiarFormulario();
        setopenModal(false);
        setLoader({ ...loader, loading: false });
        showNotification(
          "success",
          "Solicitud Creada con Éxito",
          "Tu folio es:" + request.data.data.folio,
          null,
        );

      } else {
        setState({
          ...state,
          citizenSelected: "",
          numTour: "",
          nameTour: "",
          observations: "",
        });
        setopenModal(false);
        limpiarFormulario();
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Crear Solicitud",
          request.data.message,
          null,
          4,
        );
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Favor de llenar los campos",
        null,
        4,
      );
    }
  };

  const editRequest = async () => {
    if (validarEditar) {
      setLoader({ ...loader, loading: true });
      const editarPeticion = await services({
        method: "PUT",
        service: `petitions/${state.citizenEditSelected.id}`,
        body: {
          subject: state.citizenEditSelected.subject?.toUpperCase(),
          priority: state.citizenEditSelected.priority,
          area_id : state.citizenEditSelected.area_id,
          judgment: state.citizenEditSelected.judgment,
          status_id: state.citizenEditSelected.status_id,
          observations: state.citizenEditSelected.observations?.toUpperCase(),
          services_provided: normalizeServicesProvided(
            state.citizenEditSelected.services_provided,
          ),
          reason: state.citizenEditSelected.reason,
          process_number:
            state.citizenEditSelected.process_number ??
            state.citizenEditSelected.application?.victim?.authority
              ?.process_number,
          CA:
            state.citizenEditSelected.CA ??
            state.citizenEditSelected.application?.victim?.authority?.CA,
          sede: state.citizenEditSelected.sede,
          cause: state.citizenEditSelected.cause,
          other_accions: state.citizenEditSelected.other_accions,
          situation: state.citizenEditSelected.situation,
          in_contr_of: state.citizenEditSelected.in_contr_of
        },
      });
      if (editarPeticion.status === 200) {

        setLoader({ ...loader, loading: false });

        recargarPeticiones();
        setOpenModalEditar(false);
        showNotification(
          "success",
          "Solicitud",
          "Se ha editado con Éxito",
          null,
          4,
        );

      } else {
        setLoader({ ...loader, loading: false });

        setOpenModalEditar(false);
        showNotification(
          "error",
          "Ups...",
          "Error al editar la solicitud",
          null,
          4,
        );
      }
    } else {
      showNotification(
        "error",
        "Ups...",
        "Error favor de llenar los campos",
        null,
        4,
      );
    }
  };

  const deleteRequest = async () => {
    setLoader({ ...state, loading: true });
    const eliminarPeticion = await services({
      method: "DELETE",
      service: `petitions/${state.citizenEditSelected.id}`,
      body: null,
    });
    if (eliminarPeticion.status === 200) {

      setOpenModalEliminar(false);
      recargarPeticiones();
      showNotification("success", "Petición Eliminada con Éxito", "", null, 4);
      setLoader({ ...state, loading: false });

    } else if (eliminarPeticion.status === 409) {
      setLoader({ ...state, loading: false });

      setOpenModalEliminar(false);
      showNotification(
        "error",
        "Ups...",
        "Error la petición seleccionada no se puede eliminar.",
        null,
        4,
      );
    } else {
      setLoader({ ...state, loading: false });

      setOpenModalEliminar(false);
      showNotification(
        "error",
        "Ups...",
        "Error al Eliminar el Solicitud",
        null,
        4,
      );
    }
  };

  const crearPeticion = async () => {
    setLoader({ ...loader, loading: true });
    if (validarFormularioPeticion()) {
      const peticion = await services({
        method: "POST",
        service: "petitions",
        body: {
          application_id: state.citizenEditSelected.id,
          subject: formularioPeticionState.subject,
          area_id: formularioPeticionState.area_id,
          priority: formularioPeticionState.priority,
        },
      });
      if (peticion.status === 201) {

        showNotification("success", "Petición", "Creada con Éxito", null, 4);
        limpiarFormularioPeticion();

        recargarPeticiones();
        setOpenModalPeticion(false);
        setLoader({ ...loader, loading: false });
        setPeticion(peticion.data.folio);
        // goTo(`/peticionesCiudadano/${state.citizenEditSelected.ciudadano_id}`);

      } else {

        setOpenModalPeticion(false);
        setLoader({ ...loader, loading: false });
        limpiarFormularioPeticion();
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al Crear Petición",
          null,
          4,
        );
      }
    } else {
      showNotification(
        "error",
        "Ups... ",
        "Por favor llena los campos marcados",
        null,
        4,
      );
      setLoader({ ...loader, loading: false });
    }
  };

  const editarCiudadano = async () => {
    setLoader({ ...loader, loading: true });
    if (validarEditarCiudadano()) {
      const ciudadano = await services({
        method: "POST",
        service: `ciudadanos/editar`,
        body: {
          id: state.ciudadano.id,
          cat_tipo_titulo_id: state.ciudadano.cat_tipo_titulo_id,
          nombre: state.ciudadano.nombre?.toUpperCase(),
          apellido_paterno: state.ciudadano.apellido_paterno?.toUpperCase(),
          apellido_materno: state.ciudadano.apellido_materno?.toUpperCase(),
          tipo_persona: state.ciudadano.tipo_persona,
          edad: state.ciudadano.edad,
          sexo: state.ciudadano.sexo,
          ine: state.ciudadano.ine.toUpperCase(),
          cat_tipo_cargo_id: state.ciudadano.cat_tipo_cargo_id,
          telefono: state.ciudadano.telefono,
          email: state.ciudadano.email?.toUpperCase(),

          calle: state.ciudadano.calle?.toUpperCase(),
          numero_ext: state.ciudadano.numero_ext?.toUpperCase(),
          colonia: state.ciudadano.colonia?.toUpperCase(),
          cp: state.ciudadano.cp,
          estado: state.ciudadano.estado,
          municipio_id: state.ciudadano.municipio_id,
          localidad_id: state.ciudadano.localidad_id,
        },
      });
      if (ciudadano.status === 200) {

        recargarPeticiones();
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Algo Sucedió",
          ciudadano.data.message,
          null,
          4,
        );
        setState({ ...state, openModalEditar: false });
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
    }
  };

  const enviarArchivos = async () => {
    setLoader({ ...loader, loading: true });
    if (selectedFile !== null) {
      if (!validarArchivoPdf(selectedFile)) {
        setLoader({ ...loader, loading: false });
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }

      const formData = new FormData();
      formData.append("file", selectedFile);

      let response = await services({
        method: "POST",
        service: `petitions/${selectedItemId.id}/documents`,
        body: formData,
      });

      if (response.status === 201) {
        let listaAdjuntos = await services({
          method: "GET",
          service: `petitions/${selectedItemId.id}/documents`,
          body: null,
        });

        if (listaAdjuntos.status === 200) {
          const documentos = normalizarAdjuntos(listaAdjuntos.data || listaAdjuntos);

          setLoader({ ...loader, loading: false });
          setState((prev) => ({
            ...prev,
            adjuntos: documentos,
            openAdjuntos: true,
          }));
          showNotification(
            "success",
            "Éxito",
            "Se ha cargado su archivo",
            null,
            4
          );
          setSelectedFile(null);
          fileInputRef.current.value = "";
        } else {
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Ups...",
            "Ocurrió algo al cargar su archivo",
            null,
            4
          );
          setSelectedFile(null);
          handleCloseAdjuntos();
          fileInputRef.current.value = "";
        }
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Error",
          response.data?.message?.archivo?.[0] || "No se pudo subir el archivo",
          null,
          4
        );
        setSelectedFile(null);
        handleCloseAdjuntos();
        fileInputRef.current.value = "";
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Favor de seleccionar un archivo",
        null,
        4
      );
      setSelectedFile(null);
    }
  };


  const eliminarAdjunto = async (id_documento) => {
    setLoader({ ...loader, loading: true });
    const formData = new FormData();
    formData.append("id", id_documento);
    let response = await services({
      method: "DELETE",
      service: `petitions/documents/${id_documento}`,
      body: null,
    });

      if (response.status === 200) {
        let listaAdjuntos = await services({
          method: "GET",
          service: `petitions/${selectedItemId.id}/documents`,
          body: null,
        });

        if (listaAdjuntos.status === 200) {
          const documentos = normalizarAdjuntos(listaAdjuntos.data || listaAdjuntos);

          setLoader({ ...loader, loading: false });
          setState((prev) => ({
            ...prev,
            adjuntos: documentos,
            openAdjuntos: true,
          }));
          showNotification(
            "success",
            "Éxito",
            "Se ha eliminado su archivo",
            null,
            4
          );
          setSelectedFile(null);
          fileInputRef.current.value = "";
        } else {
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Ups...",
            "Ocurrió algo al eliminar su archivo",
            null,
            4
          );
          setSelectedFile(null);
          handleCloseAdjuntos();
          fileInputRef.current.value = "";
        }
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Error",
          response.data?.message?.archivo?.[0] || "No se pudo eliminar el archivo",
          null,
          4
        );
        setSelectedFile(null);
        handleCloseAdjuntos();
        fileInputRef.current.value = "";
      }
  };

  const cerrarPreviewDocumento = () => {
    setState((prev) => ({
      ...prev,
      openPreviewDocumento: false,
      previewDocumentoUrl: "",
      previewDocumentoNombre: "",
      previewDocumentoMime: "",
    }));
  };

  const verAdjunto = async (documento) => {
    if (!documento?.id) return;

    setLoader({ ...loader, loading: true });

    const isApplicationDocument = Boolean(documento.application_id);
    const service = isApplicationDocument
      ? `/documents/${documento.id}/download`
      : `/petitions/documents/${documento.id}/download`;

    let response = await services({
      method: "GET",
      service,
      responseType: "blob",
    });

    if (response.status === 200) {
      const mimeType = response?.headers?.["content-type"] || response.data?.type || "application/pdf";
      const url = window.URL.createObjectURL(response.data);

      setState((prev) => ({
        ...prev,
        openPreviewDocumento: true,
        previewDocumentoUrl: url,
        previewDocumentoNombre: documento.original_name || "documento",
        previewDocumentoMime: mimeType,
      }));

      showNotification(
        "success",
        "Vista previa",
        "Se está mostrando el archivo",
        null,
        4
      );
    } else {
      showNotification(
        "error",
        "Ups...",
        "Ocurrió algo al abrir el archivo",
        null,
        4
      );
    }

    setLoader({ ...loader, loading: false });
  };

  const turnarAsesor = async () => {
    if (!validarTurnarAsesor()) {
      showNotification(
        "error",
        "Ups...",
        "Error favor de llenar los campos",
        null,
        4,
      );
      return;
    }

    setLoader({ ...loader, loading: true });
    const response = await services({
      method: "PUT",
      service: `/petitions/${selectedItemId.id}/assignAdviser`,
      body: {
        adviser_id: state.asesorSeleccionado,
      },
    });

    setLoader({ ...loader, loading: false });

    if (response?.status === 200) {
      recargarPeticiones();
      handleCloseAsesores();
      showNotification(
        "success",
        "Asesor",
        "Se ha turnado al asesor seleccionado",
        null,
        4,
      );
    } else {
      showNotification(
        "error",
        "Ups...",
        "Error al turnar asesor",
        null,
        4,
      );
    }
  };
  
  const handleCitizen = (e) => {
    setFormulario((formularioState) => ({
      ...formularioState,
      victim_id: e ? e.id : null,
    }));
  };

  const handleObservations = (e) => {
    setFormulario({ ...formularioState, observations: uppercaseText(e.target.value)});
  };

  const handleCollective = (e) => {
    setFormulario({ ...formularioState, collective: e.target.value });
  };
  const handleEditPriority = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        priority: e.target.value,
      },
    });
  };
  const handleEditArea = async (e) => {
    if (e === null) {
      setState({
        ...state,
        citizenEditSelected: {
          ...state.citizenEditSelected,
          area_id: "",
        },
      });
    } else {      
        setState({
          ...state,
          citizenEditSelected: {
            ...state.citizenEditSelected,
            area_id: e ? e.id : null,
          },
        });
    }
  };
  const handleEditSubject = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        subject: uppercaseText(e.target.value),
      },
    });
  };
 const handleEditJudgment = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        judgment: e.target.value,
      },
    });
  };
  const handleEditStatus = (e) => {
    const nextStatusId = e ? e.id : null;

    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        status_id: nextStatusId,
        cause: nextStatusId === 3 ? null : "",
      },
    });
  };
  const handleEditObservations = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        observations: uppercaseText(e.target.value),
      },
    });
  };
  const handleEditServicesProvided = (e) => {
    const value = Array.isArray(e.target.value)
      ? e.target.value
      : e.target.value
        ? [e.target.value]
        : [];

    const services = normalizeServicesProvided(value);
    const hasPsicoterapia = services.includes("PSICOTERAPIA");

    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        services_provided: services,
        status_id: hasPsicoterapia
          ? state.citizenEditSelected.status_id
          : 4, //pendiente ver que estatus corresponde si no tiene psicoterapia
        reason: hasPsicoterapia ? state.citizenEditSelected.reason : null,
      },
    });
  };
  const handleEditReason = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        reason: e.target.value,
      },
    });
  };
  const handleEditProcessNumber = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        process_number: uppercaseText(e.target.value),
      },
    });
  };
  const handleEditCA = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        CA: uppercaseText(e.target.value),
      },
    });
  };
  const handleEditSede = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        sede: e.target.value,
      },
    });
  };
  const handleEditCause = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        cause: e.target.value,
      },
    });
  };
  const getSituationOptions = (otherAccions) => {
    switch (otherAccions) {
      case "IMPUGNACIONES":
        return [
          { value: "PROCEDENTE", label: "PROCEDENTE" },
          { value: "INPROCEDENTE", label: "INPROCEDENTE" },
        ];
      case "MEDIDAS_GESTIONADAS":
        return [
          { value: "DE PROTECCIÓN", label: "DE PROTECCIÓN" },
          { value: "CAUTELARES", label: "CAUTELARES" },
        ];
      default:
        return [
          { value: "PROCEDENTE", label: "PROCEDENTE" },
          { value: "INPROCEDENTE", label: "INPROCEDENTE" },
          { value: "DE PROTECCIÓN", label: "DE PROTECCIÓN" },
          { value: "CAUTELARES", label: "CAUTELARES" },
        ];
    }
  };

  const handleEditOtherAccions = (e) => {
    const nextValue = e.target.value;
    const currentSituation =
      state.citizenEditSelected.situation ??
      state.citizenEditSelected?.procedural_states?.[0]?.situation ??
      "";
    const validSituations = getSituationOptions(nextValue).map(
      (option) => option.value,
    );

    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        other_accions: nextValue,
        in_contr_of: nextValue === "IMPUGNACIONES"
          ? state.citizenEditSelected.in_contr_of ??
            state.citizenEditSelected?.procedural_states?.[0]?.in_contr_of ??
            ""
          : null,
        situation: validSituations.includes(currentSituation)
          ? currentSituation
          : "",
      },
    });
  };
  const handleEditSituation = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        situation: e.target.value,
      },
    });
  };
  const handleEditInContrOf = (e) => {
    setState({
      ...state,
      citizenEditSelected: {
        ...state.citizenEditSelected,
        in_contr_of: e.target.value,
      },
    });
  };
  const handleSubject = (e) => {
       setFormulario({ ...formularioState, subject: uppercaseText(e.target.value)});
  };
  const handlePriority = (e) => {
    setFormularioPeticion({
      ...formularioPeticionState,
      priority: e.target.value,
    });
  };
  const handleArea = (e) => {
    setFormularioPeticion((formularioPeticionState) => ({
      ...formularioPeticionState,
      area_id: e ? e.id : null,
    }));
  };

  // const handleChangeDate = (e) => {
  //   const selectedDate = dayjs(e.$d);
  //   setFormulario({
  //     ...formularioState,
  //     fecha_audiencia: selectedDate.format("YYYY-MM-DD"),
  //   });
  // };

  // const handleChangeFont = (e) => {
  //   setFormulario({ ...formularioState, fuente_solicitud_id: e.target.value });
  // };
  const handleClose = () => {

    setOpenModalEditar(false);
  };
  const handleCloseEditarCiudadano = () => {
    setState({ ...state, openEditarCiudadano: false });
  };

  const handleCloseEliminar = () => {

    setOpenModalEliminar(false);
  };

  const handleClosePeticion = () => {

    setOpenModalPeticion(false);
  };

  const handleCloseFiltro = () => {
    setState({ ...state, openFiltro: false });
  };

  const handleSeleccionadoTitulo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, cat_tipo_titulo_id: e.target.value },
    });
  };
  const handleSeleccionadoNombre = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, nombre: e.target.value },
    });
  };
  const handleSeleccionadoApellidoPaterno = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, apellido_paterno: e.target.value },
    });
  };
  const handleSeleccionadoApellidoMaterno = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, apellido_materno: e.target.value },
    });
  };
  const handleSeleccionadoTipo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, tipo_persona: e.target.value },
    });
  };
  const handleSeleccionadoSexo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, sexo: e.target.value },
    });
  };
  const handleSeleccionadoIne = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, ine: e.target.value },
    });
  };
  const handleSeleccionadoCargo = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, cat_tipo_cargo_id: e ? e.id : null },
    });
  };
  const handleSeleccionadoTelefono = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, telefono: e.target.value },
    });
  };
  const handleSeleccionadoEmail = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, email: e.target.value },
    });
  };

  const handleSeleccionadoEdad = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, edad: e.target.value },
    });
  };
  const handleSeleccionadoCalle = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, calle: e.target.value },
    });
  };
  const handleSeleccionadoNumero = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, numero_ext: e.target.value },
    });
  };
  const handleSeleccionadoColonia = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, colonia: e.target.value },
    });
  };
  const handleSeleccionadoCp = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, cp: e.target.value },
    });
  };
  const handleSeleccionadoEstado = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, estado: e.target.value },
    });
  };
  const handleSeleccionadoMunicipio = async (e) => {
    let localidades = await services({
      method: "POST",
      service: `catLocalidades/listaPorMunicipio`,
      body: { municipio_id: e.target.value },
    });
    if (localidades.status === 200) {
      setState({
        ...state,
        localidades: localidades.data.data,
        ciudadano: { ...state.ciudadano, municipio_id: e.target.value },
      });
    } else {
      showNotification("error", "Ups...", localidades.data.message, null, 4);
    }
  };
  const handleSeleccionadoLocalidad = (e) => {
    setState({
      ...state,
      ciudadano: { ...state.ciudadano, localidad_id: e.target.value },
    });
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (!buscar) {
        getCitizensAndRequests(page, pageSize, applicationId, status_group);
      } else {
        validarBuscador(page);
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [page, pageSize, applicationId, status_group]);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={6}>
              {/* <TextField
                sx={{
                  borderRadius: "30px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                fullWidth
                size="small"
                id="busqueda"
                type="text"
                label="Buscar..."
                variant="outlined"
                value={buscador.texto}
                error={!!buscador.error}
                helperText={buscador.error || ""}
                onChange={handleChangeBuscador}
                InputProps={{
                  maxLength: 100,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setPage(0);
                          validarBuscador();
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Grid>

            <Grid item>
              {/* <ColorButton
                startIcon={<SearchIcon />}
                className="me-3"
                onClick={openModalFiltro}
              >
                Filtro
              </ColorButton> */}
              {/* <ColorButton
                startIcon={<RiFileExcel2Line />}
                className="me-3"
                onClick={exportar}
              >
                exportar
              </ColorButton> */}
              {/* <ColorButton
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  openModalAñadir();
                }}
              >
                Añadir Petición
              </ColorButton> */}
            </Grid>
          </Grid>
        </div>
        <Box sx={{ flexGrow: 2 }}>
          <Grid className="container mt-3 mb-3" maxWidth="xl">
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                data={state.requests}
                title={`TABLA DE PETICIONES/SERVICIOS`}
                columns={columns}
                options={customOptions}
              />
            </ThemeProvider>
          </Grid>
        </Box>

        <Modal
          open={state.openDetalles}
          onClose={() => handleCloseDetalles()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={styleDetalles}>
            <h3 className="TitulosProgramas mb-4">DETALLES</h3>
            <Grid container columns={12} spacing={3}>
              <span className=""></span>
              <Grid item xs={12}>
                <h5 className="mt-3 border-bottom">INFORMACIÓN DE LA VÍCTIMA</h5>
              </Grid>

              <Grid item xs={12}>
                <p>
                  <span style={colorTitle}> SEXO:</span>
                  <span>{state.detalles.application?.victim?.sex}</span>
                  {"  |  "}
                  <span style={colorTitle}>EDAD:</span>
                  <span>{state.detalles.application?.victim?.age}</span>
                </p>
                <p>
                   <span style={colorTitle}> ESTADO CIVIL:</span>
                   <span>{state.detalles.application?.victim?.marital_status}</span>
                </p>
                <p>
                  <span style={colorTitle}>DOMICILIO:</span>
                  <span>
                  {state.detalles.application?.victim?.street}/
                  {state.detalles.application?.victim?.number}/
                  {state.detalles.application?.victim?.colony}
                  </span>
                  {"  |  "}
                  <span style={colorTitle}>LOCALIDAD:</span>
                  <span>{state.detalles.application?.victim?.locality?.name}</span>
                </p>
                <p>
                  <span style={colorTitle}>RESUMEN DE LOS HECHOS:</span>
                  <span> {state.detalles.application?.victim?.fact?.facts}</span>
                </p>
              </Grid>
            
              <Grid item xs={12}>
                {state.detalles.application?.victim?.indirect_victim?.map(
                  (victim, index) => (
                    <div key={index}>
                      <p>
                        <span style={colorTitle}>NOMBRE DE LA VÍCTIMA DIRECTA:</span> 
                        <span>{victim.full_name}</span>
                        {"  |  "}
                         <span style={colorTitle}>PARENTESCO:</span>
                         <span>{victim.relationship}</span> 
                      </p>
                    </div>
                  )
                )}
                <p>
                  <span style={colorTitle}>VIOLENCIA DE GÉNERO: </span>
                  <span>{state.detalles.application?.victim?.observation?.gender_violence
                  ? "SI"
                  : "NO"}
                  </span>
                  {"  |  "}
                  <span>{state.detalles.application?.victim?.observation?.violence_type?.join(", ")}</span>
                </p>                
              </Grid>

              <Grid item xs={12}> 
                <p className="mt-2 border-bottom" style={colorTitle}>PROCESO JUDICIAL</p>
                <p>
                  <span style={colorTitle}>FECHA DE INICIO: </span>
                  <span>{state.detalles.application?.victim?.authority?.judicial_start_date}</span>
                  {"  |  "}
                  <span style={colorTitle}>COMPETENCIA:</span>          
                  <span>{state.detalles.application?.victim?.authority?.judicial_jurisdiction}</span>
                </p>
                <p>
                  <span style={colorTitle}>NÚMERO DE JUZGADO:</span>
                  <span>{state.detalles.application?.victim?.authority?.court_number}</span>
                </p>
                <p>
                  <span style={colorTitle}>NÚMERO DE PROCESO:</span> 
                  <span>{state.detalles.application?.victim?.authority?.process_number}</span>
                </p>
                <p>
                  <span style={colorTitle}>CARPETA DE ANTECEDENTES:</span> 
                  <span>{state.detalles.application?.victim?.authority?.CA}</span>
                </p>
                <p>
                  <span style={colorTitle}>VIOLACIONES A DERECHOS HUMANOS:</span> 
                  <span>{state.detalles.application?.authority?.complaint_ddhh ? "SI" : "NO"}</span>
                  {"  |  "}
                  <span style={colorTitle}>COMPETENCIA:</span> 
                  <span>{state.detalles.application?.victim?.authority?.ddhh_competence}</span>
                </p>
                <p>
                  <span style={colorTitle}>SERVICIOS SOLICITADOS:{" "}</span>
                  <span>{state.detalles.application?.victim?.complementary_form?.requested_services?.join(
                    ", "
                  )}</span>
                </p>                
                <p>
                  <span style={colorTitle}>PERTENECE A GRUPO VULNERABLE:{" "}</span>
                  <span>{state.detalles.application?.victim?.complementary_form?.is_vulnerable_group
                    ? "SI"
                    : "NO"} </span>
                  {"  |  "}
                  <span>{state.detalles.application?.victim?.complementary_form?.vulnerable_group?.join(", ")}</span>
                </p>
                <p>
                  <span style={colorTitle}>INFORMACIÓN SOBRE EL GRUPO VULNERABLE:{" "}</span>
                  <span>{state.detalles.application?.victim?.complementary_form?.notes}</span>
                </p>
                <p>
                  <span style={colorTitle}>NOMBRE DEL IMPUTADO:</span> 
                  <span>{state.detalles.application?.victim?.complementary_form?.offender_name}</span>
                </p>
                <p>
                  <span style={colorTitle}>RELACIÓN O PARENTESCO:</span> 
                  <span>{state.detalles.application?.victim?.complementary_form?.relationship}</span>
                </p>
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    handleCloseDetalles();
                  }}
                >
                  Cerrar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        <Modal
          open={state.openEditarCiudadano}
          onClose={handleCloseEditarCiudadano}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <h3 className="TitulosProgramas">EDITAR CIUDADANO</h3>
            <hr />
            <h5>DATOS GENERALES</h5>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="TITULO"
                  variant="outlined"
                  select
                  error={!!errors.titulo}
                  helperText={errors.titulo || ""}
                  onChange={handleSeleccionadoTitulo}
                  value={state.ciudadano.cat_tipo_titulo_id}
                >
                  {/* {titulosState.data &&
                    titulosState.data.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.tipo_titulo}
                      </MenuItem>
                    ))} */}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="NOMBRE"
                  variant="outlined"
                  error={!!errors.nombre}
                  helperText={errors.nombre || ""}
                  value={state.ciudadano.nombre}
                  onChange={handleSeleccionadoNombre}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoP"
                  label="APELLIDO PATERNO"
                  variant="outlined"
                  error={!!errors.apellidoPaterno}
                  helperText={errors.apellidoPaterno || ""}
                  value={state.ciudadano.apellido_paterno}
                  onChange={handleSeleccionadoApellidoPaterno}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoM"
                  label="APELLIDO MATERNO"
                  variant="outlined"
                  error={!!errors.apellidoMaterno}
                  helperText={errors.apellidoMaterno || ""}
                  value={state.ciudadano.apellido_materno}
                  onChange={handleSeleccionadoApellidoMaterno}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="TIPO"
                  variant="outlined"
                  select
                  error={!!errors.tipo}
                  helperText={errors.tipo || ""}
                  onChange={handleSeleccionadoTipo}
                  value={state.ciudadano.tipo_persona}
                >
                  <MenuItem value={1}>CIUDADANO</MenuItem>
                  <MenuItem value={0}>ASOCIACIÓN CIVIL</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-INE"
                  label="EDAD"
                  variant="outlined"
                  error={!!errors.edad}
                  helperText={errors.edad || ""}
                  onChange={handleSeleccionadoEdad}
                  value={state.ciudadano.edad}
                  inputProps={{ maxLength: 2 }}
                  onKeyPress={onlyNumber}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="GÉNERO"
                  variant="outlined"
                  select
                  error={!!errors.genero}
                  helperText={errors.genero || ""}
                  onChange={handleSeleccionadoSexo}
                  value={state.ciudadano.sexo}
                >
                  <MenuItem value={"MASCULINO"}>MASCULINO</MenuItem>
                  <MenuItem value={"FEMENINO"}>FEMENINO</MenuItem>
                  <MenuItem value={"LGTBIQA+"}>LGTBIQA+</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-INE"
                  label="INE"
                  variant="outlined"
                  error={!!errors.ine}
                  helperText={errors.ine || ""}
                  onChange={handleSeleccionadoIne}
                  value={state.ciudadano.ine}
                  inputProps={{ maxLength: 13 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  // options={cargosState.data || []}
                  getOptionLabel={(option) => option.tipo_cargo}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  // value={
                  //   cargosState.data.find(
                  //     (option) =>
                  //       option.id === state.ciudadano.cat_tipo_cargo_id,
                  //   ) || null
                  // }
                  onChange={(event, newValue) =>
                    handleSeleccionadoCargo(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="CARGO"
                      error={!!errors.cargo}
                      helperText={errors.cargo || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-telefono"
                  label="TELÉFONO"
                  variant="outlined"
                  error={!!errors.telefono}
                  helperText={errors.telefono || ""}
                  onChange={handleSeleccionadoTelefono}
                  value={
                    state.ciudadano.telefono !== null
                      ? state.ciudadano.telefono
                      : ""
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-correo"
                  label="CORREO"
                  variant="outlined"
                  value={
                    state.ciudadano.email !== null ? state.ciudadano.email : ""
                  }
                  error={errors.email}
                  helperText={errors.email || ""}
                  onChange={handleSeleccionadoEmail}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
              <hr />
              <hr />
              <h5 className="ms-4 mt-3">DIRECCIÓN</h5>
              <hr />
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-calle"
                  label="CALLE"
                  variant="outlined"
                  error={errors.calle}
                  helperText={errors.calle || ""}
                  value={state.ciudadano.calle}
                  onChange={handleSeleccionadoCalle}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-numero"
                  label="NUMERO"
                  variant="outlined"
                  error={errors.numero}
                  helperText={errors.numero || ""}
                  value={state.ciudadano.numero_ext}
                  onChange={handleSeleccionadoNumero}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="COLONIA"
                  variant="outlined"
                  error={errors.colonia}
                  helperText={errors.colonia || ""}
                  value={state.ciudadano.colonia}
                  onChange={handleSeleccionadoColonia}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-cp"
                  label="C.P."
                  variant="outlined"
                  error={errors.cp}
                  helperText={errors.cp || ""}
                  value={state.ciudadano.cp !== null ? state.ciudadano.cp : ""}
                  onChange={handleSeleccionadoCp}
                  inputProps={{ maxLength: 5 }}
                  onKeyPress={onlyNumber}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-localidad"
                  label="ENTIDAD FEDERATIVA"
                  variant="outlined"
                  select
                  error={errors.estado}
                  helperText={errors.estado || ""}
                  value={state.ciudadano.estado}
                  onChange={handleSeleccionadoEstado}
                >
                  <MenuItem value={"AGUASCALIENTES"}>AGUASCALIENTES</MenuItem>
                  <MenuItem value={"BAJA CALIFORNIA"}>BAJA CALIFORNIA</MenuItem>
                  <MenuItem value={"BAJA CALIFORNIA SUR"}>
                    BAJA CALIFORNIA SUR
                  </MenuItem>
                  <MenuItem value={"CAMPECHE"}>CAMPECHE</MenuItem>
                  <MenuItem value={"CHIAPAS"}>CHIAPAS</MenuItem>
                  <MenuItem value={"CHIHUAHUA"}>CHIHUAHUA</MenuItem>
                  <MenuItem value={"CIUDAD DE MÉXICO"}>
                    CIUDAD DE MÉXICO
                  </MenuItem>
                  <MenuItem value={"COAHUILA DE ZARAGOZA"}>
                    COAHUILA DE ZARAGOZA
                  </MenuItem>
                  <MenuItem value={"COLIMA"}>COLIMA</MenuItem>
                  <MenuItem value={"DURANGO"}>DURANGO</MenuItem>
                  <MenuItem value={"GUANAJUATO"}>GUANAJUATO</MenuItem>
                  <MenuItem value={"GUERRERO"}>GUERRERO</MenuItem>
                  <MenuItem value={"HIDALGO"}>HIDALGO</MenuItem>
                  <MenuItem value={"JALISCO"}>JALISCO</MenuItem>
                  <MenuItem value={"ESTADO DE MÉXICO"}>
                    ESTADO DE MÉXICO
                  </MenuItem>
                  <MenuItem value={"MICHOACÁN"}>MICHOACÁN</MenuItem>
                  <MenuItem value={"MORELOS"}>MORELOS</MenuItem>
                  <MenuItem value={"NAYARIT"}>NAYARIT</MenuItem>
                  <MenuItem value={"NUEVO LEÓN"}>NUEVO LEÓN</MenuItem>
                  <MenuItem value={"OAXACA"}>OAXACA</MenuItem>
                  <MenuItem value={"PUEBLA"}>PUEBLA</MenuItem>
                  <MenuItem value={"QUERÉTARO"}>QUERÉTARO</MenuItem>
                  <MenuItem value={"QUINTANA ROO"}>QUINTANA ROO</MenuItem>
                  <MenuItem value={"SAN LUIS POTOSÍ"}>SAN LUIS POTOSÍ</MenuItem>
                  <MenuItem value={"SINALOA"}>SINALOA</MenuItem>
                  <MenuItem value={"SONORA"}>SONORA</MenuItem>
                  <MenuItem value={"TABASCO"}>TABASCO</MenuItem>
                  <MenuItem value={"TAMAULIPAS"}>TAMAULIPAS</MenuItem>
                  <MenuItem value={"TLAXCALA"}>TLAXCALA</MenuItem>
                  <MenuItem value={"VERACRUZ"}>VERACRUZ</MenuItem>
                  <MenuItem value={"YUCATÁN"}>YUCATÁN</MenuItem>
                  <MenuItem value={"ZACATECAS"}>ZACATECAS</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="MUNICIPIO"
                  variant="outlined"
                  select
                  error={!!errors.municipio}
                  helperText={errors.municipio || ""}
                  onChange={handleSeleccionadoMunicipio}
                  value={state.ciudadano.municipio_id}
                >
                  {state.municipios &&
                    state.municipios.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.municipio}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="LOCALIDAD"
                  variant="outlined"
                  select
                  error={!!errors.localidad}
                  helperText={errors.localidad || ""}
                  onChange={handleSeleccionadoLocalidad}
                  value={state.ciudadano.localidad_id}
                >
                  {state.localidades.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.localidad}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value={null}>
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    editarCiudadano();
                  }}
                >
                  EDITAR
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModal}
          onClose={() => setopenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">CREAR SOLICITUD</h3>
            <Grid container columns={12} spacing={3}>
              
              <Grid item xs={12}>
                <Autocomplete
                  options={state.citizens || []}
                  getOptionLabel={(option) =>
                    option.full_name
                  }
                  fullWidth
                  size="small"
                  id="victim_id"
                  sx={{ borderRadius: "30px" }}
                  value={
                    state.citizens.find(
                      (option) => option.id === formularioState.victim_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleCitizen(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="NOMBRE DE LA VICTIMA"
                      error={!!errors.citizen}
                      helperText={errors.citizen || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="collective"
                  label="COLECTIVO"
                  variant="outlined"
                  select
                  error={!!errors.collective} 
                  helperText={errors.collective || ""}
                  value={formularioState.collective}
                  onChange={handleCollective}
                >
                  <MenuItem value={"EN TU BÚSQUEDA MICHOACÁN"}>EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                  <MenuItem value={"BUSCANDO TUS PASOS"}>BUSCANDO TUS PASOS</MenuItem>
                  <MenuItem value={"DECOFEM"}>DECOFEM</MenuItem>
                  <MenuItem value={"DECOMICH"}>DECOMICH</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="OBSERVACIONES"
                  multiline
                  rows={3}
                  value={formularioState.observations}
                  error={!!errors.observations}
                  helperText={errors.observations || ""}
                  onChange={handleObservations}
                />
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton onClick={createRequest}>Crear</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalEditar}
          onClose={() => handleClose()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">Editar Petición</h3>
            <Grid container columns={12} spacing={3}>
              {!isAreaJuridica && !isAsesor && !isFondoAyuda && !isUnidadesRegionales && !isAreaPsicologica && !isPsicologo && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="ASUNTO"
                    value={state.citizenEditSelected.subject}
                    error={!!errors.subject}
                    helperText={errors.subject || ""}
                    onChange={handleEditSubject}
                  />
                </Grid>
              )}
              {!isAreaJuridica && !isAsesor && !isFondoAyuda && !isUnidadesRegionales && !isAreaPsicologica && !isPsicologo && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <Autocomplete
                    options={state.areas || []}
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    size="small"
                    id="textFile-area"
                    sx={{
                      borderRadius: "30px",
                    }}
                    value={
                      state.areas.find(
                        (option) =>
                          option.id === state.citizenEditSelected.area_id,
                      ) || null
                    }
                    onChange={(event, newValue) => handleEditArea(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        variant="outlined"
                        label="AREA"
                        error={!!errors.area_id}
                        helperText={errors.area_id || ""}
                      />
                    )}
                  />
                </Grid>
              )}
              {!isAreaJuridica && !isAsesor && !isFondoAyuda && !isUnidadesRegionales && !isAreaPsicologica  && !isPsicologo && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="priority"
                    label="PRIORIDAD"
                    variant="outlined"
                    select
                    error={!!errors.priority} 
                    helperText={errors.priority || ""}
                    value={state.citizenEditSelected.priority}
                    onChange={handleEditPriority}
                  >
                    <MenuItem value="ORDINARIO">ORDINARIO</MenuItem>
                    <MenuItem value="URGENTE">URGENTE</MenuItem>
                    <MenuItem value="URGENTE_TERMINO">URGENTE CON TERMINO</MenuItem>
                  </TextField>
                </Grid>
              )}
              {!isPrimerContacto && !isFondoAyuda && !isUnidadesRegionales && !isAreaPsicologica  && !isPsicologo && !isAcompañamientoVictimas && !EsconderAsesores &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="judgment"
                    label="TIPO DE ASUNTO"
                    variant="outlined"
                    select
                    error={!!errors.judgment} 
                    helperText={errors.judgment || ""}
                    value={state.citizenEditSelected.judgment}
                    onChange={handleEditJudgment}
                  >
                    <MenuItem value="JUICIO SUCESORIO">JUICIO SUCESORIO</MenuItem>
                    <MenuItem value="NULIDAD DE CONTRATO">NULIDAD DE CONTRATO</MenuItem>
                    <MenuItem value="INCUMPLIMIENTO DE CONTRATO">INCUMPLIMIENTO DE CONTRATO</MenuItem>
                    <MenuItem value="GUARDA Y CUSTODIA Y PENSIÓN ALIMENTICIA">GUARDA Y CUSTODIA Y PENSIÓN ALIMENTICIA</MenuItem>
                    <MenuItem value="DIVORCIO">DIVORCIO</MenuItem>
                    <MenuItem value="DECLARACIÓN DE AUSENCIA">DECLARACIÓN DE AUSENCIA</MenuItem>
                    <MenuItem value="PRESUNCIÓN DE MUERTE">PRESUNCIÓN DE MUERTE</MenuItem>
                    <MenuItem value="LEVANTAMIENTO DE ACTA DE DEFUNCIÓN">LEVANTAMIENTO DE ACTA DE DEFUNCIÓN</MenuItem>
                    <MenuItem value="PÉRDIDA DE LA PATRIA POTESTAD">PÉRDIDA DE LA PATRIA POTESTAD</MenuItem>
                    <MenuItem value="ADMINISTRATIVO">ADMINISTRATIVO</MenuItem>
                    <MenuItem value="OTRO">OTRO</MenuItem>
                  </TextField>
                </Grid>
              )}
              {!isAreaJuridica  &&!isAsesor && !isFondoAyuda && !isUnidadesRegionales && !isAcompañamientoVictimas && !isPrimerContacto &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    required
                    fullWidth
                    size="small"
                    id="services_provided"
                    label="SERVICIOS PROPORCIONADOS"
                    variant="outlined"
                    select
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => selected.join(", "),
                    }}
                    error={!!errors.services_provided}
                    helperText={errors.services_provided || ""}
                    value={normalizeServicesProvided(
                      state.citizenEditSelected.services_provided,
                    )}
                    onChange={handleEditServicesProvided}
                  >
                    <MenuItem value="PSICOTERAPIA">PSICOTERAPIA</MenuItem>
                    <MenuItem value="CONTENCIÓN">CONTENCIÓN</MenuItem>
                    <MenuItem value="ACOMPAÑAMIENTO">ACOMPAÑAMIENTO</MenuItem>
                    <MenuItem value="EVALUACIÓN">EVALUACIÓN</MenuItem>
                    <MenuItem value="PREPARACIÓN PARA AUDIENCIA">PREPARACIÓN PARA AUDIENCIA</MenuItem>
                    <MenuItem value="CANALIZACIÓN">CANALIZACIÓN</MenuItem>
                  </TextField>
                </Grid>
              )}
              {!isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="sede"
                    label="SEDE"
                    variant="outlined"
                    select
                    error={!!errors.sede} 
                    helperText={errors.sede || ""}
                    value={
                      state.citizenEditSelected.sede ??
                      state.citizenEditSelected?.procedural_states?.[0]?.sede ?? 
                      ""
                    }
                    onChange={handleEditSede}
                    >
                    <MenuItem value="SEDE MINISTERIAL">SEDE MINISTERIAL</MenuItem>
                    <MenuItem value="SEDE JUDICIAL">SEDE JUDICIAL</MenuItem>
                  </TextField>
                </Grid>
              )}
              {shouldShowStatusField && (
                <Grid item xs={12}>
                  <Autocomplete
                    options={state.status || []}
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    size="small"
                    id="textFile-status"
                    sx={{
                      borderRadius: "30px",
                    }}
                    value={
                      state.status.find(
                        (option) =>
                          option.id === state.citizenEditSelected.status_id,
                      ) || null
                    }
                    onChange={(event, newValue) => handleEditStatus(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="ESTATUS"
                        error={!!errors.status_id}
                        helperText={errors.status_id || ""}
                      />
                    )}
                  />
                </Grid>
              )}
              {!isAreaJuridica  && !isAsesor && !isFondoAyuda && !isUnidadesRegionales && !isAcompañamientoVictimas && !isPrimerContacto && hasPsicoterapiaService && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="reason"
                    label="MOTIVO"
                    variant="outlined"
                    select
                    error={!!errors.reason} 
                    helperText={errors.reason || ""}
                    value={state.citizenEditSelected.reason}
                    onChange={handleEditReason}
                  >
                    <MenuItem value="RECHAZO EL SERVICIO">RECHAZO EL SERVICIO</MenuItem>
                    <MenuItem value="FALTAS">FALTAS</MenuItem>
                  </TextField>
                </Grid>
              )}
              {!isStatusEnTramite && !isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="cause"
                    label="CAUSA"
                    variant="outlined"
                    select
                    error={!!errors.cause} 
                    helperText={errors.cause || ""}
                    value={
                      state.citizenEditSelected.cause ??
                      state.citizenEditSelected?.procedural_states?.[0]?.cause ?? 
                      ""
                    }
                    onChange={handleEditCause}
                  >
                    <MenuItem value="NO EJERCICIO DE LA  ACCIÓN PENAL">NO EJERCICIO DE LA  ACCIÓN PENAL</MenuItem>
                    <MenuItem value="FACULTAD DE ABSTENERSE DE INVESTIGAR">FACULTAD DE ABSTENERSE DE INVESTIGAR</MenuItem>
                    <MenuItem value="ACUERDO REPARATORIO">ACUERDO REPARATORIO</MenuItem>
                    <MenuItem value="SOBRESEIMIENTOS">SOBRESEIMIENTOS</MenuItem>
                    <MenuItem value="SUSPENSIÓN CONDICIONAL">SUSPENSIÓN CONDICIONAL</MenuItem>
                    <MenuItem value="SENTENCIA ABSOLUTORIA">SENTENCIA ABSOLUTORIA</MenuItem>
                    <MenuItem value="SENTENCIA CONDENATORIA">SENTENCIA CONDENATORIA</MenuItem>
                    <MenuItem value="SENTENCIA MIXTA">SENTENCIA MIXTA</MenuItem>
                    <MenuItem value="SENTENCIA">SENTENCIA</MenuItem>
                    <MenuItem value="SENTENCIA EN PROCEDIMIENTO ABREVIADO">SENTENCIA EN PROCEDIMIENTO ABREVIADO</MenuItem>
                    <MenuItem value="LIBERTAD ANTICIPADA O SUSTITUTIVOS PENALES">LIBERTAD ANTICIPADA O SUSTITUTIVOS PENALES</MenuItem>
                    <MenuItem value="PROCEDIMIENTO INTERNO">PROCEDIMIENTO INTERNO</MenuItem>
                    <MenuItem value="DESIGNACIÓN DE ASESOR PARTICULAR">DESIGNACIÓN DE ASESOR PARTICULAR</MenuItem>

                  </TextField>
                </Grid>
              )}
              {!isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="other_accions"
                    label="OTRAS ACCIONES"
                    variant="outlined"
                    select
                    error={!!errors.other_accions} 
                    helperText={errors.other_accions || ""}
                    value={
                      state.citizenEditSelected.other_accions ??
                      state.citizenEditSelected?.procedural_states?.[0]?.other_accions ?? 
                      ""
                    }
                    onChange={handleEditOtherAccions}
                  >
                    <MenuItem value="IMPUGNACIONES">IMPUGNACIONES</MenuItem>
                    <MenuItem value="MEDIDAS_GESTIONADAS">MEDIDAS GESTIONADAS</MenuItem>
                  </TextField>
                </Grid>
              )}
              {!isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="situation"
                    label="SITUACIÓN/TIPO"
                    variant="outlined"
                    select
                    error={!!errors.situation} 
                    helperText={errors.situation || ""}
                    value={
                      state.citizenEditSelected.situation ??
                      state.citizenEditSelected?.procedural_states?.[0]?.situation ?? 
                      ""
                    }                    
                    onChange={handleEditSituation}
                  >
                    {getSituationOptions(
                      state.citizenEditSelected.other_accions ??
                        state.citizenEditSelected?.procedural_states?.[0]?.other_accions,
                    ).map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              {isImpugnaciones && !isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda && !isAcompañamientoVictimas &&(
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="in_contr_of"
                    label="EN CONTRA DE"
                    variant="outlined"
                    select
                    error={!!errors.in_contr_of} 
                    helperText={errors.in_contr_of || ""}
                    value={
                      state.citizenEditSelected.in_contr_of ??
                      state.citizenEditSelected?.procedural_states?.[0]?.in_contr_of ?? 
                      ""
                    }                     
                    onChange={handleEditInContrOf}
                  >
                    <MenuItem value="LA DETERMINACIÓN DEL MINISTERIO PÚBLICO">LA DETERMINACIÓN DEL MINISTERIO PÚBLICO</MenuItem>
                    <MenuItem value="APELACIÓN">APELACIÓN</MenuItem>
                    <MenuItem value="JUICIO DE AMPARO">JUICIO DE AMPARO</MenuItem>
                  </TextField>
                </Grid>
              )}
              {!isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda &&(
                <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="CAUSA PENAL"
                      value={
                        state.citizenEditSelected.process_number ??
                        state.citizenEditSelected.application?.victim?.authority
                          ?.process_number ??
                        ""
                      }
                      error={!!errors.process_number}
                      helperText={errors.process_number || ""}
                      onChange={handleEditProcessNumber}
                    />
                </Grid>
              )}
              {!isFondoAyuda && !isAreaPsicologica && !isPsicologo && !isPrimerContacto && !isFondoAyuda  &&(
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="CARPETA DE ANTECEDENTES"
                    value={
                      state.citizenEditSelected.CA ??
                      state.citizenEditSelected.application?.victim?.authority
                        ?.CA ??
                      ""
                    }
                    error={!!errors.CA}
                    helperText={errors.CA || ""}
                    onChange={handleEditCA}
                  />
                </Grid>
              )}
              {!isPrimerContacto && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="OBSERVACIONES"
                    multiline
                    rows={5}
                    value={state.citizenEditSelected.observations}
                    error={!!errors.observations}
                    helperText={errors.observations || ""}
                    onChange={handleEditObservations}
                  />
                </Grid>
              )}
              <Grid marginLeft="auto" item>
                <ColorButton onClick={editRequest}>Editar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalEliminarState}
          onClose={handleCloseEliminar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style}>
            <h3 className="TitulosProgramas mb-3">
              ¿ESTÁ SEGURO DE ELIMINAR LA PETICIÓN DE?
            </h3>

            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <h4>{state.citizenEditSelected?.application?.victim?.name}, PARA EL ÁREA: {state.citizenEditSelected?.area?.name}  </h4>
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    deleteRequest();
                  }}
                >
                  Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openModalPeticion}
          onClose={() => handleClosePeticion()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">CREAR PETICIÓN</h3>
            <Grid container columns={12} spacing={3}>              
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-subject"
                  label="ASUNTO"
                  variant="outlined"
                  error={!!errors.subject}
                  helperText={errors.subject || ""}
                  value={formularioState.subject}
                  onChange={handleSubject}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={state.areas || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.areas.find(
                      (option) =>
                        option.id === formularioPeticionState.area_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleArea(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="AREA"
                      error={!!errors.area_id}
                      helperText={errors.area_id || ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="priority"
                  label="PRIORIDAD"
                  variant="outlined"
                  select
                  error={!!errors.priority}
                  helperText={errors.priority || ""}
                  onChange={handlePriority}
                  value={formularioPeticionState.priority}
                >
                  <MenuItem value="ORDINARIO">ORDINARIO</MenuItem>
                  <MenuItem value="URGENTE">URGENTE</MenuItem>
                  <MenuItem value="URGENTE_TERMINO">URGENTE CON TERMINO</MenuItem>
                </TextField>
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    crearPeticion();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <ModalText
          open={state.openDescripcion}
          onClose={() => handleCloseDescripcion()}
          descripcion={state.descripcion}
        />

        <Modal
          open={state.openAsesores}
          onClose={handleCloseAsesores}
          aria-labelledby="modal-asesores-title"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <h3 className="TitulosProgramas mb-4">
              {isAreaJuridica
                ? "Seleccionar Asesor"
                : isAreaPsicologica
                ? "Seleccionar Psicólogo"
                : "Seleccionar Asesor"}
            </h3>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                {state.asesores?.map((asesor) => (
                  <Button
                    key={asesor.id}
                    fullWidth
                    variant={
                      state.asesorSeleccionado === asesor.id
                        ? "contained"
                        : "outlined"
                    }
                    sx={{ mb: 1, justifyContent: "flex-start" }}
                    onClick={() =>
                      setState((prev) => ({
                        ...prev,
                        asesorSeleccionado: asesor.id,
                      }))
                    }
                  >
                    {asesor.name}
                  </Button>
                ))}
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="flex-end">
                <ColorButton
                  // disabled={!state.asesorSeleccionado}
                  onClick={() => {
                    turnarAsesor();
                  }}
                >
                  {isAreaJuridica
                  ? "Turnar Asesor"
                  : isAreaPsicologica
                  ? "Turnar Psicólogo"
                  : "Turnar Asesor"}
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openAdjuntos}
          onClose={() => handleCloseAdjuntos()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <h3 className="TitulosProgramas mb-4">Archivos Adjuntos</h3>
            <Grid container columns={12} spacing={2}>
              {state.adjuntos && state.adjuntos.length > 0 ? (
                state.adjuntos.map((item, index) => {
                  const isApplicationDocument = Boolean(item.application_id);
                  const canDeleteDocument = !isApplicationDocument;
                  const docLabel = isApplicationDocument
                    ? item.type || "DOCUMENTO DE SOLICITUD"
                    : "DOCUMENTO DE RESPUESTA";

                  return (
                    <Grid item xs={12} key={`${item.id || index}-${docLabel}`}>
                      <Grid
                        container
                        spacing={2}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Grid item xs={canDeleteDocument ? 8 : 10}>
                          <Link
                            component="button"
                            variant="body2"
                            onClick={() => verAdjunto(item)}
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "block",
                            }}
                          >
                            {item.original_name}
                          </Link>
                          <small style={{ color: "#666" }}>{docLabel}</small>
                        </Grid>
                        {canDeleteDocument && (!isLectura) && (
                          <Grid item xs={2}>
                            <Button
                              onClick={() => {
                                if (!canDeleteDocument) return;
                                eliminarAdjunto(item.id);
                              }}
                            >
                              <IconUI size={"20px"} color={"red"}>
                                <AiOutlineDelete />
                              </IconUI>
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12}>
                  <p>No hay documentos adjuntos.</p>
                </Grid>
              )}

              {!isLectura && (
                <Grid item xs={12}>
                  <input
                    accept="*/*"
                    style={{ display: "none" }}
                    id="file-upload-input"
                    type="file"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                  <label htmlFor="file-upload-input">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      startIcon={<CloudUploadIcon />}
                    >
                      Subir Archivo
                    </Button>
                  </label>
                  {selectedFile && (
                    <div>
                      <p>Nombre del archivo: {selectedFile.name}</p>
                    </div>
                  )}
                </Grid>
              )}

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    enviarArchivos();
                  }}
                >
                  Enviar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        
        <Modal
          open={state.openPreviewDocumento}
          onClose={cerrarPreviewDocumento}
          aria-labelledby="preview-documento-title"
          aria-describedby="preview-documento-description"
        >
          <Box className="contenedorModalUrs" sx={{
            ...style2,
            width: "90%",
            maxWidth: 1000,
            height: "85vh",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <h3 className="TitulosProgramas mb-0">
                  {state.previewDocumentoNombre || "Vista previa"}
                </h3>
              </Grid>
              <Grid item>
                <ColorButton onClick={cerrarPreviewDocumento}>Cerrar</ColorButton>
              </Grid>
            </Grid>

            {state.previewDocumentoUrl ? (
              state.previewDocumentoMime?.includes("pdf") ? (
                <iframe
                  title="preview-documento"
                  src={state.previewDocumentoUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "500px",
                    border: "none",
                    borderRadius: "12px",
                  }}
                />
              ) : state.previewDocumentoMime?.startsWith("image/") ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <img
                    src={state.previewDocumentoUrl}
                    alt={state.previewDocumentoNombre}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      borderRadius: "12px",
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <a href={state.previewDocumentoUrl} target="_blank" rel="noreferrer">
                    Abrir archivo en nueva ventana
                  </a>
                </Box>
              )
            ) : (
              <p>No hay vista previa disponible.</p>
            )}
          </Box>
        </Modal>

        <Modal
          open={state.openFiltro}
          onClose={() => handleCloseFiltro()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style3}>
            <h3 className="TitulosProgramas">Filtro</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="FOLIO"
                  value={filtroSolicitud.folio}
                  error={!!errors.folio}
                  helperText={errors.folio || ""}
                  onChange={handleFiltroFolio}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="CIUDADANO"
                  value={filtroSolicitud.ciudadano}
                  error={!!errors.ciudadano}
                  helperText={errors.ciudadano || ""}
                  onChange={handleFiltroCiudadano}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  select
                  label="ESTADO"
                  value={filtroSolicitud.estado}
                  error={!!errors.estado}
                  helperText={errors.estado || ""}
                  onChange={handleFiltroEstado}
                >
                  <MenuItem value={"NUEVO INGRESO"}>NUEVO INGRESO</MenuItem>
                  <MenuItem value={"INICIADA"}>INICIADA</MenuItem>
                  <MenuItem value={"ATENDIDA"}>ATENDIDA</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="FECHA"
                    slotProps={{ textField: { size: "small" } }}
                    sx={{ width: 1 }}

                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    onChange={handleFiltroFecha}
                    value={filtroSolicitud.fecha}

                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="FUENTES"
                  variant="outlined"
                  select
                  error={!!errors.font}
                  helperText={errors.font || ""}
                  onChange={handleFiltroFuente}
                  value={filtroSolicitud.fuente_solicitud}
                >
                  {state.fonts.map((item) => (
                    <MenuItem key={item.id} value={item.fuente_solicitud}>
                      {item.fuente_solicitud}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="NÚMERO DE GIRA"
                  value={filtroSolicitud.numero_gira}
                  error={!!errors.numero_gira}
                  helperText={errors.numero_gira || ""}
                  onChange={handleFiltroNumero}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="LUGAR DE GIRA"
                  value={filtroSolicitud.lugar_gira}
                  error={!!errors.lugar_gira}
                  helperText={errors.lugar_gira || ""}
                  onChange={handleFiltroLugar}
                />
              </Grid>
              <Grid marginLeft="auto" marginBottom={2} marginTop={2} item>
                <ColorButton
                  className="me-2"
                  onClick={() => {
                    limpiarFiltros();
                  }}
                >
                  LIMPIAR
                </ColorButton>
                <ColorButton
                  onClick={() => {
                    // setExportarBandera(2);
                    recargarPeticiones(0);
                  }}
                >
                  BUSCAR
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PeticionesVictimasView;
